var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2114 6.62932L13.5376 6.53659C13.5807 7.15344 13.5386 7.77625 13.41 8.38578L12.0837 8.20901C12.2045 7.68911 12.2464 7.15617 12.2114 6.62932Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86302 3.50258C0.929834 5.72646 1.16528 9.09349 3.38916 11.0267C5.35506 12.7356 8.21429 12.7499 10.1866 11.1939L11.0251 12.2307C8.55992 14.1846 4.97399 14.171 2.51441 12.033C-0.262918 9.61866 -0.557555 5.40516 1.85674 2.62783C3.17358 1.11299 5.02566 0.336736 6.88802 0.335783L6.88802 1.66954C5.39862 1.66848 3.91777 2.28923 2.86302 3.50258Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13728 5.69879L8.96987 3.59063L9.8542 2.57466L10.7385 1.55869C10.9178 1.68581 11.0925 1.82295 11.2619 1.97016L11.765 2.40753L8.14356 6.57353C8.29674 7.00702 8.21807 7.50398 7.89442 7.8763C7.41331 8.42976 6.56685 8.48895 6.01339 8.00784C5.45994 7.52673 5.40075 6.68027 5.88186 6.12681C6.20552 5.75449 6.68232 5.61246 7.13728 5.69879Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0655 9.51224C12.7962 10.1751 12.4149 10.8054 11.9195 11.3753C11.8838 11.4164 11.8476 11.4571 11.811 11.4971L10.9133 10.5005C11.2705 10.0896 11.5533 9.63929 11.7634 9.16625L13.0655 9.51224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.f6059a3ba0931ecd56541ec61fc88c56.svg";
export { ForwardRef as ReactComponent };